// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_PYzPb","help":"help_d-J-4","g-lower-alpha":"g-lower-alpha","g-no-bullet":"g-no-bullet","ant-modal-body":"ant-modal-body"};